import Pusher from "pusher-js";

let pusherInstance: Pusher | null = null;

function getCsrfToken(): string | undefined {
	const match = document.cookie.match(/(?:^|;\s*)csrf-token=([^;]*)/);
	return match ? decodeURIComponent(match[1]) : undefined;
}

export function getPusherClient(key: string, cluster = "eu"): Pusher {
	if (pusherInstance) {
		return pusherInstance;
	}

	pusherInstance = new Pusher(key, {
		cluster,
		authorizer: (channel) => ({
			authorize: (socketId, callback) => {
				fetch("/broadcasting/auth", {
					method: "POST",
					credentials: "include",
					headers: {
						"Content-Type": "application/json",
						"x-csrf-token": getCsrfToken() ?? "",
					},
					body: JSON.stringify({
						socket_id: socketId,
						channel_name: channel.name,
					}),
				})
					.then((res) => {
						if (!res.ok) throw new Error(`Broadcasting auth failed: ${res.status}`);
						return res.json();
					})
					.then((data) => callback(null, data))
					.catch((err) => callback(err, null));
			},
		}),
	});

	return pusherInstance;
}

export function disconnectPusher(): void {
	if (pusherInstance) {
		pusherInstance.disconnect();
		pusherInstance = null;
	}
}
